import axios from 'axios';

export function getAutocheckVehicleHistory(VIN, referenceId, product, report, config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const reference = referenceId || '';
  const url = `${config.getAutocheckVehicleHistory}?VIN=${VIN}&referenceId=${reference}&product=${product}&report=${report}`;
  // console.log(url);
  // console.log(axios.defaults.common);
  return dispatch => dispatch({
    type: 'AUTOCHECK_VEHICLE_HISTORY_FETCH',
    payload: axios({ method: 'get', url, headers })
  }).catch((error) => {
    console.log(error);
  });
}

export function clearAutocheckVehicleHistory() {
  return {
    type: 'AUTOCHECK_VEHICLE_HISTORY_CLEAR',
    payload: ''
  };
}


// WEBPACK FOOTER //
// ./src/actions/getAutocheckVehicleHistory.js